var map = {
	"./check-params.js": "hOAs",
	"./load-courses.js": "1M30",
	"./locale.js": "LPu5"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "56n9";


//////////////////
// WEBPACK FOOTER
// /resources/js/middleware nonrecursive .*\.js$
// module id = 56n9
// module chunks = 6